import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useUsage } from '../hooks/useUsage';

// Small inline pill shown in the FormBuilder header when the user is near
// or at the per-form fields limit. Drives them to upgrade without
// interrupting the build flow.
export const FieldsLimitPill = ({ fieldsCount }) => {
  const { usage, isEnterprise } = useUsage();

  if (!usage || isEnterprise) return null;
  const max = usage.limits?.max_fields_per_form;
  if (!max || usage.unlimited?.fields_per_form) return null;

  const pct = (fieldsCount / max) * 100;
  if (pct < 80) return null;

  const isCritical = fieldsCount >= max;
  const styles = isCritical
    ? 'bg-rose-50 border-rose-200 text-rose-700'
    : 'bg-amber-50 border-amber-200 text-amber-700';

  return (
    <span
      data-testid="fields-limit-pill"
      title={`${usage.plan_display_name} plan allows up to ${max} fields per form. Upgrade for more.`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${styles}`}
    >
      <AlertTriangle className="w-3 h-3" />
      {fieldsCount}/{max} fields
    </span>
  );
};
